import { GetStaticProps } from 'next'
import { getAllMaps, getAllCategories } from '#/containers/Gallery/lib/api'

export { default } from '#/containers/Gallery'

export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  const allMaps = await getAllMaps(preview, 1000, null)
  const categories = await getAllCategories()
  return {
    props: { allMaps, preview, categories },
    revalidate: 1
  }
}
